export default {
  title: "关于我们",
  mission_vision: "使命与愿景",
  mission_vision_desc:
    "我们的使命是以超过90%的准确率帮助中小企业快速实现欧盟CBAM合规，降低成本并提高效率，同时支持2026年可持续发展目标。",
  team: "团队介绍",
  team_desc:
    "TaxEcoBit是由专业人士构建的CBAM合规SaaS平台，致力于为中小企业提供高效可靠的工具，简化合规流程，并持续更新以满足欧盟监管要求。",
  contact: "联系我们",
  contact_email: "邮箱: {email}",
  follow_us: "关注我们:",
  newsletter: "新闻通讯",
  newsletter_desc: "订阅我们的新闻通讯，获取最新的CBAM政策解读、合规技巧和功能更新。",
  newsletter_button: "订阅",
  agreement_text:
    "我同意使用此邮箱接收最新的CBAM政策解读、合规技巧和功能更新，并同意根据GDPR要求处理我的个人数据。",
  support: "即时支持",
  support_desc:
    "我们已编制常见问题解答供您快速自助查询；如需进一步帮助，您可以随时提交工单，我们的支持团队将在24-48小时内回复。",
  support_button: "联系支持",
  chat_opened: "支持窗口已打开",
  newsletter_success: "订阅成功: {email}",
};
